
import { HourlyPlanTypeEnum, LocationModel, WorkplaceModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { workplacesStore } from '@/libs/workplaces/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import WorkplaceDialog from '../components/WorkplaceDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        WorkplaceDialog,
    },
})
export default class Workplaces extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('workplaces.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('workplaces.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('workplaces.location'), value: 'location.name', align: 'left', sortable: false },
            { text: this.$i18n.t('shift.hourlyPlanType'), value: 'hourlyPlanType', align: 'left', sortable: false },
            { text: this.$i18n.t('workplaces.costs'), value: 'costs', align: 'left', sortable: false },
            {
                text: this.$i18n.t('workplaces.skipShiftImportColumn'),
                value: 'skipShiftImport',
                align: 'left',
                sortable: false,
            },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: WorkplaceDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return workplacesStore.useGetter(CrudGetter.Pending);
    }

    get locations(): WorkplaceModel[] {
        return [...workplacesStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...workplacesStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        workplacesStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<WorkplaceModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: WorkplaceModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }

    formatCost(v: number | null | undefined) {
        return v == null ? (this.$t('costs.inherited') as any) : v;
    }

    getHourlyPlanTypeLabel(type: HourlyPlanTypeEnum | undefined): string {
        if (!type) {
            return '--';
        }
        return type === HourlyPlanTypeEnum.ByCycleTime
            ? (this.$t('shift.hourlyPlanTypeByCycleTime') as string)
            : (this.$t('shift.hourlyPlanTypeByEntry') as string);
    }
}
